<script>
import PbxService from "@/helpers/APIService/pbx.service";
import errorHandler from "@/helpers/errorHandler";
import PageHeader from "@/components/page-header.vue";
import Drawer from "@/components/drawer";
import handleLogic from "@/helpers/handleLogic";

//  Custom components
import securityGroup from "@/components/superAdmin/securityGroup/secutiryGroupList.vue";

export default {
  page: {
    title: "Security Group",
  },
  data() {
    return {
      title: "Security Group",
      openSecurityGroupDrawer: false,
      groupList: [],
      listedData: [],
      unListedData: [],
      currId: "",
      isLoading: false,
      now_loading: true,
      loadNow: false,
    };
  },
  components: {
    PageHeader,
    Drawer,
    securityGroup,
  },
  mounted() {
    this.getSecurityGroups();
  },
  methods: {
    getSecurityGroup(item) {
      this.isLoading = true;
      if (item != undefined) {
        this.listedData = [];
        this.unListedData = [];
        PbxService.getSecurityGroupData(item)
          .then((response) => {
            this.listedData = response.result.allow_traffic_rule;
            this.unListedData = response.result.block_traffic_rule;
            this.currId = item;
            this.isLoading = false;
            this.loadNow = true;
          })
          .catch((error) => {
            this.isLoading = false;
            errorHandler(error);
          });
      }
    },
    getSecurityGroups() {
      this.now_loading = true;
      PbxService.getSecurityGroups()
        .then((response) => {
          this.groupList = handleLogic.groupByArrayHandle(
            response.result,
            "security_group_name"
          );
          this.now_loading = false;
        })
        .catch((error) => {
          this.now_loading = false;
          errorHandler(error);
        });
    },
    setCurrName(index) {
      this.currName = index.replaceAll("_", " ");
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" :action="getSecurityGroup" />
    <b-card>
      <div class="table-responsive">
        <table class="table">
          <thead class="table-light">
            <tr>
              <th>group name</th>
              <th>Group Items</th>
            </tr>
          </thead>
          <template v-if="!now_loading && groupList.length !== 0">
            <tbody v-for="(item, index) in groupList" :key="item.id">
              <tr
                @click="
                  getSecurityGroup(item[0].security_group_id);
                  setCurrName(index);
                  openSecurityGroupDrawer = !openSecurityGroupDrawer;
                "
              >
                <td>{{ index.replaceAll("_", " ") }}</td>
                <td>
                  <div class="d-flex gap-2">
                    <span v-for="items in item" :key="items.id">
                      {{ items.server_name }},
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
          <tbody slot="body" v-else-if="now_loading">
            <tr v-for="item in 3" :key="item">
              <td class="placeholder-glow" v-for="no in 2" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody slot="body" v-else>
            <tr>
              <td colspan="9" class="text-center">
                <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
                <p>
                  <span class="text-secondary">No Data Found</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>

    <Drawer
      @close="openSecurityGroupDrawer = !openSecurityGroupDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1400"
    >
      <div v-if="openSecurityGroupDrawer">
        <securityGroup
          :listedData="listedData"
          :unListedData="unListedData"
          :currId="currId"
          :currName="currName"
          :isLoading="isLoading"
          :loadNow="loadNow"
          @update="getSecurityGroup"
          @cancelSubmit="openSecurityGroupDrawer = !openSecurityGroupDrawer"
        />
      </div>
    </Drawer>
  </div>
</template>
